import type { Rule } from '@atlas/react-forms';
import classNames from 'classnames';
import type { FC } from 'react';

import { Translation } from 'utils/translations';

import styles from './Errors.module.scss';

type ErrorsProps = {
  errors: Rule[] | string[];
  className?: string;
};

const Errors: FC<ErrorsProps> = ({ errors, className }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <ul
      className={classNames(className, styles['errors-list'], {
        [styles['single-error']]: errors.length === 1,
      })}
    >
      {errors.map((error) => {
        if (typeof error === 'string') {
          return (
            <li key={error} className={styles['errors-list-item']}>
              <Translation message={error.toLowerCase()} />
            </li>
          );
        }

        const ruleOption = error.ruleOption ?? '';

        return (
          <li
            key={`${error.behaviour}-${error.type}`}
            className={styles['errors-list-item']}
          >
            <Translation
              message={error.message.toLowerCase()}
              params={{ ruleOption }}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default Errors;
